import { Card, CardContent, FormControl, Grid } from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from 'components/Wrappers/materialUIWrappers/components/FormInput';
import NumberInput from 'components/Wrappers/materialUIWrappers/components/NumberInput';
import { percentage } from 'helpers/ValidationHelpers';
import React from 'react';
import { Field } from 'redux-form';
import { addMonths } from 'date-fns';

const required = value => (value ? undefined : 'Required');

const dates = () => {
	let options = [];
	const today = new Date();
	for (var i = 0; i < 2; i++) 
	{
		const monthX = addMonths(today, i + 2);
		var month = monthX.getMonth();
		if(month < 1)
			month = 12;

		if (month < 10)
		{
			var item = '01/0' + month + '/' + monthX.getFullYear();
			if(item.includes("/00/"))
				item.replace("/00/", "/12/")
			options.push(item);
		}
			
		else 
		{
			var item = '01/' + month + '/' + today.getFullYear()
			if(item.includes("/00/"))
				item.replace("/00/", "/12/")
			options.push(item);
		}
			

		
	}

	return options;
};

const makeOptions = values => {
	const options = [{ value: 'validationError', displayValue: 'Please select' }];
	for (let value of values) {
		if (typeof value === 'object') {
			options.push(value);
		} else {
			options.push(value);
		}
	}

	return options;
};

const CustomField = props => (
	<GridItem xs={12} sm={12} md={6} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

class QuoteDetailsPage extends React.Component {
	componentDidMount() {
		this.props.scrollMeBar();
	}

	render() {
		return (
			<div className="contentWithStepper">
				<Card>
					<CardContent>
						<CustomCardHeading
							subheading="Quote Generation"
							caption={this.props.clientFullname}
							headline="General Quote Details"
						/>
						<Grid container>
							<CustomField
								name={'description'}
								component={FormInput}
								checkValidation={this.props.checkValidation}
								label={'Quote Description *'}
								isrequired={true}
								validate={[required]}
							/>

							<CustomField
								name={'language'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Language *'}
								isrequired={true}
								validate={[required]}
								options={[
									{ value: 'English', displayValue: 'English' },
									{ value: 'Afrikaans', displayValue: 'Afrikaans' }
								]}
							/>

							<CustomField
								name={'startDate'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Start Date *'}
								isrequired={true}
								validate={[required]}
								options={makeOptions(dates())}
							/>

							<CustomField
								name={'premiumPattern'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Premium Pattern *'}
								isrequired={true}
								validate={[required]}
								options={makeOptions([
									{ value: 'Level', displayValue: 'Level' },
									{ value: 'Compulsory', displayValue: '5% Compulsory' },
									{ value: 'AgeRated', displayValue: 'Age rated' }
								])}
							/>

							<CustomField
								name={'annualIncrease'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Cover Annual Increase *'}
								isrequired={true}
								validate={[required]}
								options={makeOptions([
									{ value: '0', displayValue: '0% p.a.' },
									{ value: '5', displayValue: '5.0% p.a.' },
									{ value: '75', displayValue: '7.5% p.a. (Not available at all FSPs)' },
									{ value: '10', displayValue: '10% p.a. (Not available at all FSPs)' },
									{ value: 'CPI', displayValue: 'CPI' }
								])}
							/>

							<CustomField
								name={'Frequency'}
								component={FormDropdown}
								checkValidation={this.props.checkValidation}
								label={'Premium Frequency *'}
								isrequired={true}
								validate={[required]}
								options={makeOptions([
									{ value: '12', displayValue: 'Monthly' },
									{ value: '1', displayValue: 'Annually' }
								])}
							/>

							<CustomField
								name={'comission'}
								component={NumberInput}
								suffix="%"
								checkValidation={this.props.checkValidation}
								label={'Comission % *'}
								isrequired={true}
								validate={[required, percentage]}
							/>

							<CustomField
								name={'percentageUpfronCommission'}
								component={NumberInput}
								suffix="%"
								checkValidation={this.props.checkValidation}
								label={'Upfront commission % *'}
								isrequired={true}
								validate={[required, percentage]}
							/>

							<CustomField
								name={'PAAWCommission'}
								component={NumberInput}
								suffix="%"
								checkValidation={this.props.checkValidation}
								label={'As-and-when commission % *'}
								isrequired={true}
								validate={[required, percentage]}
							/>
						</Grid>
					</CardContent>
				</Card>
			</div>
		);
	}
}

export default QuoteDetailsPage;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/steps/QuoteDetails.jsx